<template>
  <div class="board-labels-container">
    <div class="general-labels">
      <div class="label mt-2 mb-1">General Labels</div>
      <p>Here you can select which labels should be available for selection on the board.</p>
      <div class="content-container ob-scroll">
        <div class="font-weight-bold container-fluid">
          <div class="row pt-2">
            <div class="col-3">Category</div>
            <div class="col-4">Label</div>
            <div class="col-2">Available</div>
          </div>
          <div class="row pt-2">
            <div class="col-2 offset-7">
              <checkbox-with-label
                v-model="isGeneralLabelsSelectedAll_"
                :label="isGeneralLabelsSelectedAll ? 'Unselect all' : 'Select all'"
                @input="toggleAllGeneralLabels(isGeneralLabelsSelectedAll)"
              ></checkbox-with-label>
            </div>
          </div>
        </div>

        <div class="container-fluid pt-2 pb-2">
          <div class="row pt-2 pb-1" v-for="bl in selectableGeneralBoardsLabels" :key="bl.id">
            <div class="col-3">
              {{ bl.category }}
            </div>
            <div class="col-4">
              <div class="d-flex">
                <div
                  class="bi-label mr-2 mb-1 d-flex justify-content-between align-items-center"
                  :style="{
                    'background-color': bl.color,
                    color: 'white',
                    padding: '1px 3px',
                    'border-radius': '3px',
                  }"
                >
                  <i v-if="bl.icon" :class="bl.icon" class="mr-1 ml-1 pr-1"></i>
                  <div class="pl-1 pr-1">
                    {{ bl.title }}
                  </div>
                </div>
              </div>
            </div>

            <div class="col-2">
              <checkbox-with-label label="Available" v-model="bl.isAvailable"></checkbox-with-label>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end pt-2">
        <button :disabled="isLoading" class="btn btn-save btn-sm btn-success" @click="saveGeneralBoardsLabels()">
          <i class="far fa-save"></i>
          Save changes
        </button>
      </div>
    </div>
    <hr />
    <div class="board-labels mt-4">
      <BoardsLabels />
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Component from 'vue-class-component';
  import { LabelModule, LabelStore } from '@/store/label';
  import PublicConstants from '@/types/publicConstants';
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  //@ts-ignore
  import VSwatches from 'vue-swatches';
  import BoardLabel from '@/types/boardLabel';
  import { GlobalHelper } from '@/helpers/global-helper';
  import BoardsLabels from '../BoardsSettings/BoardsLabels.vue';

  @Component({ components: { VSwatches, BoardsLabels } })
  export default class BoardLabels extends Vue {
    private labelStore: LabelModule = LabelStore;
    swatches = PublicConstants.labelColors;
    isLoading = false;

    isGeneralLabelsSelectedAll_ = false;
    selectableGeneralBoardsLabels: BoardLabel[] = [];

    async mounted() {
      await Promise.all([this.labelStore.getGeneralLabelsAsync(), this.labelStore.loadSelectedBoardLabels(this.boardId)]);

      this.initGeneralLabels();

      this.isGeneralLabelsSelectedAll_ = this.isGeneralLabelsSelectedAll;
    }

    get boardId() {
      return this.$route.params.id;
    }

    private initGeneralLabels() {
      this.selectableGeneralBoardsLabels = [];

      this.labelStore.generalActiveLabels.forEach((boardLabel: BoardLabel) => {
        boardLabel.isAvailable = this.labelStore.selectedGeneralBoardLabels.some((t) => t.labelId === boardLabel.id && t.isAvailable);

        this.selectableGeneralBoardsLabels.push({ ...boardLabel } as BoardLabel);
      });
    }

    get isGeneralLabelsSelectedAll() {
      return (
        this.selectableGeneralBoardsLabels &&
        this.selectableGeneralBoardsLabels.length &&
        this.selectableGeneralBoardsLabels.every((t) => t.isAvailable)
      );
    }

    toggleAllGeneralLabels(state) {
      this.selectableGeneralBoardsLabels.forEach((item) => {
        item.isAvailable = !state;
      });
    }

    async saveGeneralBoardsLabels() {
      this.isLoading = true;
      const labelsIds = this.selectableGeneralBoardsLabels.filter((t) => t.isAvailable).map((t) => t.id);

      await this.labelStore.updateSelectedGeneralBoardLabels({
        boardId: this.boardId,
        selectedLabels: labelsIds,
      });

      this.isLoading = false;

      GlobalHelper.NotifySuccess('Labels were successfully updated');

      this.initGeneralLabels();
    }
  }
</script>

<style scoped lang="scss">
  .board-labels-container {
  }

  .content-container {
    border-radius: 4px;
    background-color: white;
    min-height: 200px;
    max-height: 500px;
    overflow-y: auto;
    border: solid 1px #eaeaea;
  }

  .space-between {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .row {
    align-items: center;
  }
</style>